import styles from './HomeDescriptionText.module.css';
import { useTranslation } from 'react-i18next';

const HomeDescriptionText = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.textContainer}>
      <p>{t('lang.homeTitle2')}</p>
    </div>
  );
};

export default HomeDescriptionText;
